function GazeInfo(source) {
	this.x = null;
	this.y = null;
	this.fov = null;

	if (source) {
		Object.assign(this, source);
	}
}

export default GazeInfo;
